module.exports = __webpack_public_path__ + "static/media/flashSaleLightningBolt.973968f4.svg";